<template>
      <div id="coi-list-div-main">
         <b-card v-for="(customerOrder, k) in compiledCustomerOrders"
            :key="customerOrder.id"
            :style="`background-color: ${(k%2==0) ? '#FFFFFF' : 'rgb(225, 232, 240)' }`"
            class="m-2" no-body
         ><!-- card -->
            <div class="card-body p-2 pr-3 mr-2">
               <b-overlay
                     id="overlay-coi-list-card"
                     :show="queryInProgress"
                     variant="light"
                     opacity="0.5"
                     blur="2px"
                     rounded="lg"
                     :fixed="true"
               ><!-- overlay -->
                  <coi-list-item
                     :authorization="authorization"
                     :listItemIndex="k"
                     :customerOrder="customerOrder"
                     :countries="countries"
                     :orderStates="orderStates"
                     :vendors="vendors"
                     :marketAccounts="marketAccounts"
                  ></coi-list-item>
               </b-overlay>
            </div>
         </b-card>
      </div>
</template>
<script>
export default {
   props: [
      "authorization"
    , "countries"
    , "customerOrders"
    , "marketAccounts"
    , "orderStates"
    , "vendors"
    , "queryInProgress"
   ],
   computed: {
      /**
       * compiled CustomerOrders are normal COs with the countries mixed into
       * the respective marketAccounts.
       * notice: "marketaccount" is in shit-case, because Laravel.
       */
      compiledCustomerOrders: function() {
         if(!this.customerOrders) return [];
         return this.customerOrders.map( customerOrder => {
            customerOrder.marketaccount.country = this.countries
               .find( country => country.id === customerOrder.marketaccount.countryId );
            return customerOrder;
         });
      }
   }
}
</script>
